import React from 'react';


function KeyValue({ key1, value }) {

    return (
      <div className='grid font12 '>
        <div className='col-6 padding02 textBold'>
          {key1}
        </div>
        <div className='col-6 padding02'>
          {value}
        </div>
      </div>
    )
  }
  

export default KeyValue;